module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5qI3p"))).then(() => parcelRequire('3a9aZ'));